export const REMOVE_EMAIL_CONSTANTS = {
  LABEL_EMAIL:
    'Warning: If an email is removed by mistake, it will have to be manually re-added to all chats it was removed from.',
  PLACEHOLDER_EMAIL: 'example@choco.com',
  BUTTON_DISABLE_TEXT: 'Enter an email to be removed',
  BUTTON_ENABLE_TEXT: 'Remove email from all chats',
  BUTTON_EMAIL_NOT_AVAILABLE_TEXT:
    'Sorry!! This email address is not available',
  BUTTON_CHECKING_IN_PROGRESS_TEXT:
    'Checking how many chats will be affected...',
  BUTTON_NO_OF_CHATS_TEXT: (noOfChats: number) =>
    `Remove email from ${noOfChats} chat(s)`,
  MODAL_HEADER: 'Remove an additional email',
  MESSAGE_HEADER: 'EMAIL REMOVER',
  MESSAGE_SUCCESS_MESSAGE: 'Email was successfully removed',
  MESSAGE_FAILURE_MESSAGE: 'Oops! Something went wrong!',
} as const;
